const { PaymentIntent  } = require("./payment-intent");

module.exports.PaymentIntent = PaymentIntent;
